import Skeleton from "@/components/common/Skeleton";
import { useUserStore } from "@/modules/auth/store/user";
import { Avatar } from "@boringer-avatars/react";
import { useTranslation } from "react-i18next";

const Sponsor = () => {
  const { t } = useTranslation();
  const { invitedBy, refcode, isReferralLoading } = useUserStore();

  return (
    <div className="flex items-center gap-4 px-4 bg-bg rounded-[0.75rem]">
      <Avatar
        title={false}
        name={invitedBy || 0}
        size={40}
        variant="beam"
        square={false}
      />

      <div className="flex flex-col py-3 gap-0.5">
        {isReferralLoading ? (
          <Skeleton className="w-15 h-5.5" />
        ) : (
          <p className="text-[1.0625rem] leading-[1.375rem] text-text">
            {invitedBy
              ? invitedBy
              : !invitedBy && !refcode
              ? t("main-page.not_connected")
              : t("main-page.no_sponsor")}
          </p>
        )}
        <p className="text-[0.9375rem] leading-[1.25rem] text-subtitle-text">
          {t("main-page.your_sponsor_id")}
        </p>
      </div>
    </div>
  );
};

export default Sponsor;
